<template>
  <div >
    <span :class="claseError">{{titulo}}</span>
    <span v-if="obligatorio" class="font-weight-bold ml-1 red--text">*</span>
    <IconoInformacion :sInformativo="sInfoAyuda"/>
    <v-expansion-panels>
      <v-expansion-panel >
        <v-expansion-panel-header>
          <span v-if="sIconoSeleccionado==''">
            Seleccione un icono
          </span>
          <span v-else>
            Icono seleccionado: <v-icon class="icono-estilo ml-4">{{ sIconoSeleccionado }}</v-icon>
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="border-iconos">
          <v-row>
            <v-col>
              <v-text-field
              prepend-inner-icon="mdi-magnify"
              label="Buscar Icono"
              v-model="sBuscarIcono"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col v-for="(item , n) in aIconosMostrar" :key="'col'+ n"  cols="4" md="2">
              <v-icon 
              :key="'icono'+ n"
               @click="onSeleccionarIcono(item.icono)" 
               class="icono-estilo">{{ item.icono }}</v-icon>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
  </template>
  
  <script>
  import axiosServices from "@/services/axiosServices.js"
  import FormMixin from '@/mixins/formularioMixin.js'
  import IconoInformacion from '@/components/Form/Componentes/subComponentes/IconoInformacion.vue'
  
  export default {
    name: 'FormIcono',
    mixins: [FormMixin],
    components: {
      IconoInformacion,
    },
    props: {
          value: {
          },
          titulo:{
            type:String,
            default:''
          },
          obligatorio:{
            type:Boolean,
            default: false
          },
          campo:{
            type:String,
            default : ''
          },
          editable: {
            type: String,
            default: ''
          },
          inner: {
            type: String,
            default: ''
          },
          sInfoAyuda:{
            type: String,
            default: null,
          },
        },
    data() {
      return {
        sBuscarIcono:"",
        valor           : this.value,
        loadSelect      : false,
        aIconos  : [],
        aIconosMostrar:[],
        Mensaje         : 'Cargando..',
        esError         : false,
        noVacio         : [v => !!v],
        bEditable       : (this.editable == "0") ? true : false,
        sIconoSeleccionado:""
      }
    },
    mounted () {
      this.onCargarIconos();
      
    },
    methods: {
      async onCargarIconos(){
        
        this.loadSelect = true
        await axiosServices.getConfiguration('generico/iconos' , true ).then(aItems =>{
          this.aIconosMostrar = aItems.aData
          this.aIconos = aItems.aData
          this.loadSelect = false
        });

        if(this.valor!=undefined){
          //validamos si hay un dato lo seleccionamos
          let sIconoSeleccionado = this.valor;
          let oIcono = this.aIconos.find(item=> item.icono == sIconoSeleccionado);
          
          if(oIcono!=undefined){
            this.onSeleccionarIcono(oIcono.icono);
          }
        }
      },
      onSeleccionarIcono(sIcono){
        this.sIconoSeleccionado=sIcono;
        this.valor=sIcono;
      }
    },
    watch: {
      sBuscarIcono(){
        const sBuscar = this.sBuscarIcono.toLowerCase();
        if(sBuscar==""){
          this.aIconosMostrar =this.aIconos;
        }
        else{
          this.aIconosMostrar = this.aIconos.filter(item => (item.es.toLowerCase().includes(sBuscar)||item.en.toLowerCase().includes(sBuscar)));
        }
      },
      value(){
        this.valor=this.value;
      }
    },
    
  }
  </script>
  
  <style scoped>
  
  .border-iconos{
    border: 0.5px solid black;
    border-radius: 10px;
  }

  .icono-estilo{
    color: black;
    cursor: pointer;
    font-size: 40px;
  }
  </style>